import { render, staticRenderFns } from "./offlineSalary.vue?vue&type=template&id=23f5f2d4&scoped=true&"
import script from "./offlineSalary.vue?vue&type=script&lang=js&"
export * from "./offlineSalary.vue?vue&type=script&lang=js&"
import style0 from "./offlineSalary.vue?vue&type=style&index=0&id=23f5f2d4&prod&lang=scss&scoped=true&"
import style1 from "./offlineSalary.vue?vue&type=style&index=1&id=23f5f2d4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f5f2d4",
  null
  
)

export default component.exports